const videoUrlRegex = /\.(mp4|mov|webm|ogg)(\?|$)/i;
const audioUrlRegex = /\.(mp3|wav)(\?|$)/i;
export function isVideoUrl(url: string): boolean {
  return videoUrlRegex.test(url);
}

export function isAudioUrl(url: string): boolean {
  return audioUrlRegex.test(url);
}
